import { Release } from "../types";

export function doesReleaseHaveGoldDiscount(release: Release) {
  const { ppb_gold_price_point, ppb_gold_sale_price_point, premium_only } =
    release ?? {};
  return (ppb_gold_price_point || ppb_gold_sale_price_point) && premium_only;
}
